import React from "react";
import { connect } from 'react-redux';



import {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";


import {runningIndexMedian} from '../helperFunctions/RunningIndex'
import {BaseSpeedCalculate,AerobicSpeedCalculate,TempoSpeedCalculate,IntervalSpeedCalculate} from '../helperFunctions/TrainingSpeeds'
import {convertMetrics,metricSpeed} from '../helperFunctions/measurementSystem'
import Slider from 'rc-slider';


class TrainingZones extends React.Component {
  
  state = {activityDuration:60}

  componentDidMount(){
    if (!localStorage.getItem("token")){
      window.location.replace("/login")
    }
  }
  changeActivityDuration = (value) => {
      this.setState({activityDuration:value})
  }
  
  
  
  
  render() {
    
    //const loca  = localStorage.getItem('user')
    //const [runningIndex,dates]=runningIndexList(this.props.activities.entries)
    const [runningIndexMedianList,maxMedian,maxIndex] = runningIndexMedian(this.props.activities.entries)
    const currentIndex = runningIndexMedianList[runningIndexMedianList.length-1]
    localStorage.setItem('runningIndex',currentIndex)
    //console.log(currentIndex)

    const maxHr = parseInt(this.props.auth.max_hr)
    const restHr = parseInt(this.props.auth.rest_hr)
    const reserve= maxHr-restHr
    const aer1 = restHr+reserve*0.6
    const aer2 = restHr+reserve*0.7
    const aer3 = (restHr+reserve*0.7)+1
    const aer4 = restHr+reserve*0.8
    const thre1 = (restHr+reserve*0.8)+1
    const thre2 = restHr+reserve*0.9
    const max1 = (restHr+reserve*0.9)+1

     var restHrFactor = (60 - this.props.auth.rest_hr)*0.003
    const referenceSpeed = this.state.activityDuration
    const baseSpeed = BaseSpeedCalculate(referenceSpeed,currentIndex,restHrFactor)
    const aerobicSpeed = AerobicSpeedCalculate(referenceSpeed,currentIndex,restHrFactor)
    const tempoSpeed = TempoSpeedCalculate(referenceSpeed,currentIndex,restHrFactor)
    var intervalSpeed = IntervalSpeedCalculate(referenceSpeed,currentIndex)
    //console.log(maxHr,restHr,reserve)

    
    return (
      <>
        <div className="content" style={{marginTop:'40px'}}>
          <h4 style={{color:'rgb(240,240,240)'}}>Training Zones</h4>
          <p className="category"> Heart rate and speed zones</p>
            <label style={{color:'rgb(255,255,255)',marginTop:'40px'}}>Speeds are calculated for a <span style={{color:'rgb(000,199,255)',fontSize:'20px'}}>{this.state.activityDuration}</span> minute run</label>
            <Slider  min={20}  max={150} value={this.state.activityDuration} step={5} onChange={this.changeActivityDuration}/>
            <Row style={{marginTop:'40px'}}>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#cc4444',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category"  style={{color: '#FFFFFF'}}>Maximum Upper</h5>
                    <CardTitle tag="h4">{maxHr}</CardTitle>
                    </CardHeader>
                    
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#cc4444',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category"  style={{color: '#FFFFFF'}}>Maximum Lower</h5>
                    <CardTitle tag="h4">{max1.toFixed(0)}</CardTitle>
                    </CardHeader>
                
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category" style={{color: '#cc4444'}}>Interval Speed</h5>
                    <CardTitle tag="h4">{convertMetrics(intervalSpeed,this.props.auth.measurementSystem)}<span style={{fontSize:'10px',color:'#cc4444',fontWeight:'1000'}}> {metricSpeed(this.props.auth.measurementSystem)} </span></CardTitle>
                    </CardHeader>
                
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#cc8844',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category" style={{color: '#FFFFFF'}}>Threshold Upper</h5>
                    <CardTitle tag="h4">{thre2.toFixed(0)}</CardTitle>
                    </CardHeader>
                    
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#cc8844',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category" style={{color: '#FFFFFF'}}>Threshold Lower</h5>
                    <CardTitle tag="h4">{thre1.toFixed(0)}</CardTitle>
                    </CardHeader>
                
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category" style={{color: '#cc8844'}}>Tempo Speed</h5>
                    <CardTitle tag="h4">{convertMetrics(tempoSpeed,this.props.auth.measurementSystem)}<span style={{fontSize:'10px',color:'#cc8844',fontWeight:'1000'}}> {metricSpeed(this.props.auth.measurementSystem)} </span></CardTitle>
                    </CardHeader>
                
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#22cc22',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category" style={{color: '#FFFFFF'}}>Aerobic Upper</h5>
                    <CardTitle tag="h4">{aer4.toFixed(0)}</CardTitle>
                    </CardHeader>
                    
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#22cc22',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category" style={{color: '#FFFFFF'}}>Aerobic Lower</h5>
                    <CardTitle tag="h4">{aer3.toFixed(0)}</CardTitle>
                    </CardHeader>
                
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category" style={{color: '#22cc22'}}>Maximum Aerobic Speed</h5>
                    <CardTitle tag="h4">{convertMetrics(aerobicSpeed,this.props.auth.measurementSystem)}<span style={{fontSize:'10px',color:'#22cc22',fontWeight:'1000'}}> {metricSpeed(this.props.auth.measurementSystem)} </span></CardTitle>
                    </CardHeader>
                
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#4444aa',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category" style={{color: '#FFFFFF'}}>Base Upper</h5>
                    <CardTitle tag="h4">{aer2.toFixed(0)}</CardTitle>
                    </CardHeader>
                    
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#4444aa',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category" style={{color: '#FFFFFF'}}>Base Lower</h5>
                    <CardTitle tag="h4">{aer1.toFixed(0)}</CardTitle>
                    </CardHeader>
                
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
                <Col xs={12} md={4}>
                <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category" style={{color: '#6688aa'}}>Base Speed</h5>
                    <CardTitle tag="h4">{convertMetrics(baseSpeed,this.props.auth.measurementSystem)}<span style={{fontSize:'10px',color:'#6688aa',fontWeight:'1000'}}> {metricSpeed(this.props.auth.measurementSystem)} </span></CardTitle>
                    </CardHeader>
                
                    <CardFooter>
                    <div className="stats">
                        
                    </div>
                    </CardFooter>
                </Card>
                </Col>
            </Row>
            
          
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log("map",state)
  return {activities:state.activities,auth:state.auth,message:state.message}
}

export default connect(mapStateToProps)(TrainingZones);
